<template>
  <div>
    <v-form ref="packageProducts">
      <v-simple-table dense class="dense_table">
        <template v-slot:default>
          <thead>
            <tr>
              <th>{{ $t('message.layout.product') }}*</th>
              <th>{{ $t('message.product.suppliers') }}*</th>
              <th>{{ $t('message.whOrder.unitCost') }}</th>
              <th>{{ $t('message.product.salesPrice') }}</th>
              <th>{{ $t('message.order.qty') }}*</th>
              <th>{{ $t('message.common.comments') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(element, index) in packageProducts" :key="index" class="pt-4">
              <v-text-field type="text" class="hidden-sm-and-up hidden-sm-and-down" v-model="element.id"></v-text-field>
              <td width="25%">
                  <v-autocomplete v-model="element.productid" :items="element.products" autocomplete="off"
                  @keyup="$event.keyCode !== 13 ? loadProducts(`searchInput${index}`, index, $event) : ''"
                  :ref="`searchInput${index}`" class="pa-0"
                  @click="toggleAllProducts(index, SHOW)"
                  @change="setSuppliers(index)"
                  @focusout="toggleAllProducts(index, HIDE, element.productid)"
                  item-text="product_name" item-value="id" :rules="$_requiredValidation"
                  hide-details :placeholder="$t('message.common.typeHere')"></v-autocomplete>
              </td>
              <td width="20%">
                  <!-- :rules="element.product_issupplieronorder ? [] : $_requiredValidation" -->
                  <v-autocomplete v-model="element.supplierid" :items="element.suppliers" autocomplete="off" class="pa-0"
                  item-text="customer_name" item-value="supplierid" @change="getSupplierPrice(element, index)"
                  hide-details :placeholder="$t('message.common.typeHere')"></v-autocomplete>
              </td>
              <td width="10%">
                <v-text-field  class="pa-0" v-model="element.unitcost" readonly @change="priceCalculationHandler(element)" :rules="element.unitcost ? $_norwegianNumberValidation : []" hide-details :placeholder="$t('message.common.typeHere')"></v-text-field>
              </td>
              <td width="10%">
                <v-text-field  class="pa-0" v-model="element.salesprice" readonly @change="priceCalculationHandler(element)" :rules="element.salesprice ? $_norwegianNumberValidation : []" hide-details :placeholder="$t('message.common.typeHere')"></v-text-field>
              </td>
              <td width="10%">
                <v-text-field class="pa-0" v-model="element.qty" @change="priceCalculationHandler(element)" :rules="element.qty ? $_norwegianNumberValidation : $_requiredValidation" hide-details :placeholder="$t('message.common.typeHere')"></v-text-field>
              </td>
              <td width="15%">
                <v-text-field class="pa-0" v-model="element.comments" type="text" hide-details :placeholder="$t('message.common.typeHere')"></v-text-field>
              </td>
              <td>
                <v-btn class="mx-2" text fab dark small color="primary" @click="deleteProductRow(index, element.id)">
                  <v-icon dark>mdi-minus-circle</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-form>
    <v-btn class="mx-2" fab dark small color="primary" @click="addProductRowHandler">
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Object
    },
    list: {
      type: Object
    },
    modelId: {
      type: Number
    }
  },
  data () {
    return {
      isMain: '',
      packageProducts: [],
      supplierTransformList: ['supplierprice', 'supplierdiscount', 'discounted', 'shipmentaddon', 'other', 'realcost', 'realcostnok']
    }
  },
  components: {},
  computed: {},
  watch: {},
  mounted () {
    this.getAllPackageProductsHandler()
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
      this.$store.commit('hideDialog')
      if (data === 'productpackages') {
        this.getAllPackageProductsHandler(true)
      }
    })
    this.$eventBus.$on('savingParentObj', () => {
      if (this.$refs.packageProducts.validate()) {
        this.$eventBus.$emit('setChildData', this.packageProducts)
      } else {
        this.$eventBus.$emit('setChildData', false)
      }
    })
  },
  methods: {
    getProductSuppliers (productId) {
      return new Promise((resolve, reject) => {
        let query = {
          'expand': [{
            'Model': 'Customer',
            'on_field': 'Id',
            'on_parent_field': 'supplierid',
            'select': ['Name']
          }],
          'filter': `productid eq '${productId || 0}'`
        }
        this.$_executeApi('post', `productsuppliers/query`, query)
          .then((response) => {
            let transformData = { number: { list: this.supplierTransformList, format: 'replaceDotWithComma' } }
            let model = this.$_formatListModel(response.data, transformData)
            let supplierObj = model.find(x => x.ismain) ? model.find(x => x.ismain) : {}
            resolve({ list: model, default: supplierObj.supplierid, cost: supplierObj.realcostnok })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getAllPackageProductsHandler (isReloadAfterDelete = false) {
      let query = {
        'expand': [{
          'Model': 'Product',
          'on_field': 'Id',
          'on_parent_field': 'productid',
          'select': ['Name', 'Number', 'IsSupplierOnOrder', 'Weight', 'GrossWeight']
        }],
        'filter': `packageid eq ${this.modelId || 0}`
      }
      this.$_executeApi('post', `productpackages/query`, query)
        .then(async (response) => {
          let data = response.data
          let result = []
          for (let i = 0; i < data.length; i++) {
            data[i].products = []
            data[i].products.push({
              id: data[i].productid,
              product_name: data[i].product_number ? `${data[i].product_number} - ${data[i].product_name}` : data[i].product_name
            })
            data[i].suppliers = []
            data[i].weight = data[i].product_weight || 0
            data[i].grossweight = data[i].product_grossweight || 0
            let lists = await this.getProductSuppliers(data[i].productid)
            data[i].suppliers = lists.list
            result.push(data[i])
          }
          let transformData = { number: { list: ['qty', 'unitcost', 'salesprice'], format: 'replaceDotWithComma' } }
          let modelList = this.$_formatListModel(result, transformData)
          this.packageProducts = this.$formatter.cloneVariable(modelList)
          if (isReloadAfterDelete) {
            setTimeout(() => {
              this.priceCalculationHandler()
            })
          }
        })
    },
    // Searching products
    loadProducts (term, index, event) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      let searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        /* let model = {
          'filter': `number contains '${searchText}' OR name contains  '${searchText}'`,
          'additionalfilters': [`isactive eq 1`],
          'skip': 0,
          'limit': 50
        } */
        this.$_executeApi('post', `products/search_for_products?term=${searchText}&productId=${this.modelId}`).then((response) => {
          this.packageProducts[index].products = []
          if (response.data.length > 0) {
            response.data.forEach(element => {
              element.product_name = element.number ? `${element.number} - ${element.name}` : element.name
            })
            this.packageProducts[index].products = response.data
          }
        })
      }
    },
    toggleAllProducts (index, action, productId) {
      let items = this.$formatter.cloneVariable(this.packageProducts)
      if (action === this.HIDE) {
        let products = items[index].products.filter(x => x.id === productId)
        items[index].products = products
      }
      this.$set(this.packageProducts, index, items[index])
    },
    setSuppliers (index) {
      let obj = this.$formatter.cloneVariable(this.packageProducts[index])
      if (obj) {
        let getProduct = {}
        if (obj.products) {
          getProduct = obj.products.find(x => x.id === obj.productid)
          if (getProduct) {
            if (getProduct.type === 'work') {
              obj.unitcost = this.$formatter.replaceDotWithComma(getProduct.costprice)
            }
            obj.salesprice = this.$formatter.replaceDotWithComma(getProduct.salesprice)
            obj.product_issupplieronorder = getProduct.product_issupplieronorder
            let cost = this.$formatter.replaceDotWithComma(getProduct && getProduct.costprice ? getProduct.costprice : 0)
            obj.unitcost = cost
            obj.weight = getProduct.weight != null ? getProduct.weight : 0
            obj.grossweight = getProduct.grossweight != null ? getProduct.grossweight : 0
            this.$set(this.packageProducts, index, obj)
          }
        }
        this.getProductSuppliers(obj.productid)
          .then((response) => {
            obj.suppliers = response.list
            obj.supplierid = response.default
            // if (response.cost && response.cost > 0) {
            //   obj.unitcost = getProduct && getProduct.type === 'work' ? obj.unitcost : response.cost
            // }
            this.$set(this.packageProducts, index, obj)
          })
      } else {
        obj.suppliers = []
        this.$set(this.packageProducts, index, obj)
      }
    },
    getSupplierPrice (model, index) {
      let getSupplier = model.suppliers ? model.suppliers.find(x => x.supplierid === model.supplierid) : {}
      if (getSupplier) {
        let modelObj = this.$formatter.cloneVariable(this.packageProducts[index])
        modelObj.unitcost = getSupplier.realcostnok
        this.$set(this.packageProducts, index, modelObj)
        setTimeout(() => {
          this.priceCalculationHandler()
        })
      }
    },
    priceCalculationHandler () {
      let list = this.$formatter.cloneVariable(this.packageProducts)
      var price = { costprice: 0, salesprice: 0, grosmargin: 0, salespriceincvat: 0 }
      var costPrice = 0
      var salePrice = 0
      var totalWeight = 0
      var totalGrossWeight = 0
      if (list != null && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          var qty = +this.$formatter.replaceCommaWithDot(list[i].qty || 0)
          var costPerUnit = +this.$formatter.replaceCommaWithDot(list[i].unitcost)
          var salePerUnit = +this.$formatter.replaceCommaWithDot(list[i].salesprice)
          costPrice = costPrice + (qty * costPerUnit)
          salePrice = salePrice + (qty * salePerUnit)
          totalWeight += qty * +this.$formatter.replaceCommaWithDot(list[i].weight || 0)
          totalGrossWeight += qty * +this.$formatter.replaceCommaWithDot(list[i].grossweight || 0)
        }
      }
      price.costprice = costPrice
      price.salesprice = salePrice
      price.weight = totalWeight
      price.grossweight = totalGrossWeight
      if (price.costprice > 0) {
        price.grosmargin = ((salePrice - costPrice) / costPrice) * 100
      }
      var getVat = this.model.vatid
      price.salespriceincvat = (price.salesprice * (getVat + 100) / 100)
      let transformData = { number: { list: ['costprice', 'salesprice', 'grosmargin', 'salespriceincvat', 'weight', 'grossweight'], format: 'replaceDotWithComma' } }
      let resultModel = this.$_formatModel(price, transformData)
      this.$emit('priceUpdate', { model: resultModel, iscopy: !this.model.id })
      this.$store.commit('isChangesMade', true)
    },
    addProductRowHandler () {
      this.packageProducts.push({ products: [], supplierid: 0 })
    },
    deleteProductRow (index, id) {
      if (this.packageProducts[index].id) {
        let payload = { ids: [id], url: `/productpackages/delete_multiple`, module: 'productpackages' }
        this.$store.commit('showDeleteDialog', payload)
      } else this.packageProducts.splice(index, 1)
      this.priceCalculationHandler()
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('savingParentObj')
  }
}
</script>
